module.exports = __webpack_public_path__ + "static/media/eco-ecology-maple-svgrepo-com.6621bda9.svg";